export const blockIconsPlacesMeetingRoom = (
	<span className='material-symbols-outlined'>meeting_room</span>
);
